import { managerApi } from "api/managerApi";
import { utilsModule } from "modules/utils/utils-module";

type ConfirmEmailPhoneController = {
    confirm: () => Promise<void>;
    emailOrPhone: string;
    verificationCode: string;
    
    isEmail: (data: string) => boolean;
    onBackToLoginClick?: () => void;
}

function confirmEmailPhoneController(dialogs, $translate) {
    const ctrl: ConfirmEmailPhoneController = this

    ctrl.confirm = async function() {

        this.isEmail = function (data) {
            const emailRegex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
            return emailRegex.test(data);
        }
        
        const response = await managerApi.UserIdha.verifyIdentityData({
            emailValidationToken: ctrl.isEmail(ctrl.emailOrPhone) ?  ctrl.verificationCode : undefined,
            phoneValidationToken: !ctrl.isEmail(ctrl.emailOrPhone) ?  ctrl.verificationCode : undefined,
            emailOrPhone: ctrl.emailOrPhone,
            generateTemporaryAccessToken: false
        })

        if ((ctrl.isEmail(ctrl.emailOrPhone) && response.emailVerified) || 
            (!ctrl.isEmail(ctrl.emailOrPhone) && response.phoneVerified)) {
            ctrl.onBackToLoginClick?.()
        } else {
            dialogs.error($translate.instant("INVALID_VERIFICATION_CODE"))
        }
    }
}

utilsModule.component('confirmEmailPhone', {
    template: require('./confirm-email-phone.component.html'),
    controller: ['dialogs','$translate',confirmEmailPhoneController],
    bindings: {
        emailOrPhone: '=',
        onBackToLoginClick: '&'
    }
})